import styles from './Card.module.css';

const AntiqueCategoryBadge = ({ title }) => {
  return (
    <div className="d-flex justify-content-center my-4" data-aos="zoom-in">
      <div className={styles.antiqueBadge}>
        <div className={styles.innerBorder}></div>
        {title}
      </div>
    </div>
  );
};

export default AntiqueCategoryBadge;